import React from'react';
import Collapsible from'react-collapsible';
import PropTypes from'prop-types';
import'./CollapsiblePanel.css';

var CollapsiblePanel=function CollapsiblePanel(_ref){var children=_ref.children,open=_ref.open,panelText=_ref.panelText;return(
React.createElement(Collapsible,{
trigger:panelText,
open:open},

children));};



CollapsiblePanel.propTypes={
children:PropTypes.oneOfType([
PropTypes.arrayOf(PropTypes.node),
PropTypes.node]),

open:PropTypes.bool,
panelText:PropTypes.string};


CollapsiblePanel.defaultProps={
children:{},
open:false,
panelText:''};


export default CollapsiblePanel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/components/CollapsiblePanel/CollapsiblePanel.jsx
// module id = 2297
// module chunks = 0